/**
 * Normalizes the access token read from storage (string JWT or legacy object shapes).
 * @param {unknown} stored
 * @returns {string|null}
 */
export const normalizeStoredAccessToken = stored => {
  if (!stored) {
    return null;
  }
  if (typeof stored === "string") {
    return stored;
  }
  if (typeof stored === "object") {
    return stored.token ?? stored.access_token ?? null;
  }
  return null;
};

export const isTokenExpired = token => {
  if (!token) {
    return false;
  }
  return Date.now() >= token.exp * 1000;
};

export const decodeMyToken = token => {
  const accessToken = normalizeStoredAccessToken(token);
  if (!accessToken) {
    return null;
  }

  try {
    const base64Url = accessToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join("")
    );

    const payload = JSON.parse(jsonPayload);
    // Extract email from the payload
    const userEmail = payload.email || payload.upn || null; // Adjust field name if needed

    return {...payload, email: userEmail}; // Add email to the returned object
  } catch (_error) {
    return null;
  }
};
